/**
 * Definition for task status
 */
export var TASK_STATUS;
(function (TASK_STATUS) {
  TASK_STATUS["NEW"] = "new";
  TASK_STATUS["IN_PROGRESS"] = "in progress";
  TASK_STATUS["BLOCKED"] = "blocked";
  TASK_STATUS["DONE"] = "done";
})(TASK_STATUS || (TASK_STATUS = {}));